export const STORE_RELATION_SHOW_PAGE_SIZE = 10

export const STORE_RELATION_SHOW_TITLE = 'Relación Cliente-Usuario:'
export const STORE_RELATION_SHOW_STATUS_LABEL = 'Estado:'
export const STORE_RELATION_SHOW_DETAILS_TITLE = 'Detalles de la relación:'
export const STORE_RELATION_SHOW_EDIT_BUTTON_LABEL = 'Actualizar Relación'
export const STORE_RELATION_SHOW_USERS_SEARCH_PLACEHOLDER = 'Buscar usuario por nombre o código'
export const STORE_RELATION_SHOW_BRANDLESS_LABEL = 'Sin marca'
export const STORE_RELATION_SHOW_PENDING_PRINCIPAL_COLOR = '#D14343'
export const STORE_RELATION_SHOW_BRANDS_GUIDANCE_TITLE = 'Indicaciones:'
export const STORE_RELATION_SHOW_BRANDS_RULES_TITLE = 'Reglas generales:'

export const STORE_RELATION_SHOW_BRANDS_NOTE =
  'En esta sección podrá definir cómo se asignan los pedidos a los usuarios según las marcas de los productos.'

export const STORE_RELATION_SHOW_BRANDS_RULES = [
  'No se puede asignar la misma marca a dos vendedores diferentes.',
  'Las marcas sin asignación explícita se asignarán automáticamente al usuario configurado como principal.'
]

export const STORE_RELATION_SHOW_BRANDS_TABLE_COLUMNS = [
  {
    key: 'user',
    label: 'USUARIO',
    className: 'store-relations-user-column'
  },
  {
    key: 'brand',
    label: 'MARCA',
    className: 'store-relations-brands-column'
  }
]

export const STORE_RELATION_SHOW_REASSIGNMENT_WARNING_MESSAGES = {
  PRINCIPAL:
    'El usuario principal esta desactivado. Actualiza la relacion y reasigna un usuario activo.',
  USERS_PREFIX:
    'Se detectó un usuario desactivado que debe ser reasignado antes de guardar cambios: '
}

export const STORE_RELATIONS_OVERVIEW_NOTE =
  'Esta relación le indica al sistema POC a qué usuario se asignarán las órdenes procesadas. Es obligatorio definir un usuario principal para garantizar el correcto procesamiento de las órdenes provenientes de los clientes.'

export const STORE_TAB_VALUES = {
  DETAILS: 'DETAILS',
  HISTORY: 'HISTORY'
}

export const STORE_TABS = [
  {
    value: STORE_TAB_VALUES.DETAILS,
    label: 'Detalle',
    icon: 'upload_file',
    iconSize: 20,
    filled: false
  },
  {
    value: STORE_TAB_VALUES.HISTORY,
    label: 'Historial',
    icon: 'schedule',
    iconSize: 20,
    filled: false
  }
]

export const STORE_HEADER_CONFIG = {
  titleKey: 'client_name',
  cards: [
    {
      icon: 'barcode_scanner',
      label: 'Código:',
      valueKey: 'client_db_ref'
    },
    {
      icon: 'conveyor_belt',
      label: 'Proveedor:',
      valueKey: 'client_supplier_name'
    },
    {
      icon: 'source_environment',
      label: 'Cadena:',
      valueKey: 'client_buyer_name'
    },
    {
      icon: 'quick_reference',
      label: 'Referencia:',
      valueKey: 'client_reference_name'
    }
  ]
}

export const STORE_DETAILS_FIELDS = [
  {
    label: 'Usuario principal:',
    valueKey: 'principal_salesman_name'
  },
  {
    label: 'Fecha de creación:',
    valueKey: 'created_at_label'
  },
  {
    label: 'Fecha de actualización:',
    valueKey: 'updated_at_label'
  }
]

export const STORE_RELATIONS_SHOW_DEFAULT_DATA = {
  client: {},
  client_principal: {},
  client_brands: []
}
